export const HEROSHOT_MOBILE_WIDTH = 360
export const HEROSHOT_TABLET_WIDTH = 720
export const HEROSHOT_DESKTOP_WIDTH = 1080